import { RSocketTopic } from "@/infrastructure/rsocket";
import { ApiError } from "@/shared/types/error";
import { getEnv } from "@/shared/utils/env-utils.ts";
import { datadogLogs, LogsInitConfiguration } from "@datadog/browser-logs";

const dataDogConfig: LogsInitConfiguration = {
    clientToken: getEnv("VITE_DATADOG_CLIENT_TOKEN"),
    site: "datadoghq.eu",
    service: "sein-ui",
    env: getEnv("VITE_ENV"),
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["info", "warn", "error"],
    allowedTrackingOrigins: [/localhost/, /.+sein\.ns\.nl/],
};

export function initLogging() {
    datadogLogs.init(dataDogConfig);
}

export function trackRouteChange(route: string, apiDomain: string | null, traceId: string | null) {
    datadogLogs.setGlobalContextProperty("dd", { trace_id: traceId });
    datadogLogs.logger.info(`Route change: ${route}`, { route, apiDomain });
}

export function trackReceivedWebsocketEvent(type: string, channel: RSocketTopic) {
    console.info(`WS Event received: EventType="${type}" Channel="${channel}"`, { type, channel });
}

export function setUserLoggingContext(id: string, roles: string[]) {
    datadogLogs.setUser({ id, name: "REDACTED", email: "REDACTED" });
    datadogLogs.setUserProperty("roles", roles);
}

export function setUserSubscriptionsContext(currentSubscriptions: string[]) {
    datadogLogs.setUserProperty("currentSubscriptions", currentSubscriptions);
}

/**
 * Log an error to Datadog with consistent formatting
 * Logged via console.error and forwarded to Datadog through forwardConsoleLogs
 */
export function logError(message: string, error: Error, context?: Record<string, unknown>): void {
    console.error(message, {
        error: {
            message: error.message,
            name: error.name,
            stack: error.stack,
            status: (error as ApiError).status,
        },
        ...context,
    });
}
